"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Search = function Search(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: fill,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "11",
    cy: "11",
    r: "8",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "21",
    y1: "21",
    x2: "16.65",
    y2: "16.65"
  }));
};
Search.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Search.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Search;